import React from 'react';
import { FaWifi, FaRedo } from 'react-icons/fa';

/**
 * OfflineFallback — Shown when the user is offline.
 *
 * If a `featureName` prop is provided (e.g., "Social Feed"), the message
 * is contextual: "Social Feed is only available online."
 * Otherwise, a generic offline message is shown.
 */
const OfflineFallback = ({ featureName }) => {
  const handleRetry = () => {
    window.location.reload();
  };

  const isFeatureSpecific = !!featureName;

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] p-8 text-center animate-fade-in">
      <div className="bg-sand-100 dark:bg-sand-900 p-6 rounded-full mb-6 relative">
        <FaWifi className="text-4xl text-stone-400" />
        <div className="absolute bottom-4 right-4 bg-red-500 rounded-full p-1 border-2 border-white dark:border-sand-950">
           <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M6 18L18 6M6 6l12 12"></path></svg>
        </div>
      </div>
      
      <h2 className="text-xl font-bold text-stone-800 dark:text-stone-100 mb-2">
        {isFeatureSpecific ? `${featureName}` : 'You are offline'}
      </h2>
      
      <p className="text-stone-600 dark:text-stone-300 mb-6 max-w-sm">
        {isFeatureSpecific
          ? `${featureName} is only available when you're connected to the internet. Your field data and logs are still accessible offline.`
          : "It seems you've lost your internet connection. Don't worry, you can still access your previously visited fields."}
      </p>
      
      <button 
        onClick={handleRetry}
        className="flex items-center gap-2 bg-primary px-6 py-2.5 rounded-lg text-white font-medium hover:bg-forest-600 transition-colors shadow-sm"
      >
        <FaRedo className="text-sm" />
        Retry Connection
      </button>
    </div>
  );
};

export default OfflineFallback;
